<script lang="ts" setup>
import { computed } from 'vue';

import type { ChatAgentMessage } from '@sigma/chat-common/ChatEvent.js';
import { defineChatEventProps } from '@sigma/client/chat/defineChatEventProps.js';
import { MarkdownRenderer } from '@sigma/client/markdown/MarkdownRenderer.js';
import { parseMarkdown } from '@sigma/common/utils/parseMarkdown.js';
import ChatAgentAvatar from '@sigma/ui/chat/ChatAgentAvatar.vue';
import ChatEventWrapper from '@sigma/ui/chat/ChatEventWrapper.vue';
import ChatMessage from '@sigma/ui/chat/ChatMessage.vue';

import chatCss from './chat.module.scss';

const props = defineProps(defineChatEventProps<ChatAgentMessage>());
const markdown = computed(() => (props.event.message ? parseMarkdown(props.event.message) : null));
</script>

<template>
  <ChatEventWrapper
    tid="agent-message"
    :event="event"
    :class="[css.message, chatCss.container]"
  >
    <ChatMessage
      color="white"
      :timestamp="event.timestamp"
    >
      <template #avatar>
        <ChatAgentAvatar />
      </template>

      <template #content>
        <MarkdownRenderer :markdown="markdown" />
      </template>
    </ChatMessage>
  </ChatEventWrapper>
</template>

<style lang="scss" module="css">
.message {
  display: flex;
  flex-direction: column;
}
</style>
